import { render } from "./AnimatedNumber.vue?vue&type=template&id=0eef04e5&ts=true"
import script from "./AnimatedNumber.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__